var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 9L15.6465 10.9798C15.8418 11.175 15.8418 11.4916 15.6465 11.6869L13.6667 13.6666",
    stroke: "#888281",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.3336L15.72 11.3336",
    stroke: "#888281",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96289 7.81359C8.16798 8.08969 8.42963 8.31814 8.7301 8.48345C9.03057 8.64877 9.36284 8.74707 9.70435 8.7717C10.0459 8.79633 10.3887 8.74671 10.7095 8.6262C11.0303 8.5057 11.3216 8.31713 11.5636 8.07328L12.9963 6.63058C13.4312 6.17709 13.6719 5.56971 13.6665 4.93926C13.661 4.30881 13.4099 3.70574 12.9672 3.25992C12.5245 2.81411 11.9256 2.56123 11.2995 2.55575C10.6735 2.55028 10.0703 2.79264 9.61999 3.23063L8.79861 4.05297",
    stroke: "#888281",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0372 6.63124C9.83208 6.35515 9.57042 6.12669 9.26995 5.96138C8.96948 5.79607 8.63722 5.69777 8.2957 5.67314C7.95418 5.64851 7.6114 5.69813 7.2906 5.81863C6.9698 5.93914 6.67849 6.12771 6.43642 6.37156L5.00377 7.81425C4.56882 8.26775 4.32815 8.87513 4.33359 9.50558C4.33903 10.136 4.59014 10.7391 5.03285 11.1849C5.47556 11.6307 6.07444 11.8836 6.70051 11.8891C7.32657 11.8946 7.92972 11.6522 8.38006 11.2142L9.19667 10.3919",
    stroke: "#888281",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 5.6665L1.35349 3.68674C1.15823 3.49148 1.15823 3.17489 1.35349 2.97963L3.33325 0.999869",
    stroke: "#888281",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.33301L1.77782 3.33301",
    stroke: "#888281",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeGroup);
export default __webpack_public_path__ + "static/media/change-group.cc66c3288253bda10ab8b5f704b428c3.svg";
export { ForwardRef as ReactComponent };